import React, { useRef } from 'react'

import { Icon } from '@/component/atoms/Icon'
import type { StyleProps } from '@/types'
import { domUtils } from '@/utils/domUtils'

import S from './RealTimeSearchInput.style'

type Props = {
  onSearch: (text: string) => void
  size?: 'large' | 'medium' | 'small'
  placeholder?: string
  width?: React.CSSProperties['width']
  disabled?: boolean
} & StyleProps

const RealTimeSearchInput = ({
  onSearch,
  size = 'large',
  placeholder = '',
  width = 'auto',
  disabled = false,
  style,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>() as React.MutableRefObject<HTMLInputElement>

  return (
    <div css={[S.default, S.container[size], disabled && S.disabled]} style={{ width, ...style }}>
      <Icon
        className="react-time-search-icon"
        name="search"
        size={20}
        color={disabled ? 'var(--Colors-Gray-400)' : 'var(--Colors-Gray-600)'}
      />
      <input
        type="text"
        ref={inputRef}
        disabled={disabled}
        onChange={(event) => {
          onSearch(event.target.value)
        }}
        onKeyPress={domUtils.onEnter(() => {
          inputRef.current.blur()
        })}
        placeholder={placeholder}
      />
      {!disabled && (
        <button
          type="button"
          onClick={() => {
            inputRef.current.value = ''
            onSearch('')
          }}
        >
          <Icon name="close" color="var(--Colors-Gray-500)" size={16} />
        </button>
      )}
    </div>
  )
}

export default RealTimeSearchInput
